module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteWebinarReview(_vm.review.id)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "review-block"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('span', {
    staticClass: "column review-name"
  }, [_vm._v(_vm._s(_vm.review.name))]), _vm._v(" "), _c('span', {
    staticClass: "review-date column"
  }, [_vm._v(_vm._s(_vm.review.date))])]), _vm._v(" "), _c('span', {
    staticClass: "review-text"
  }, [_vm._v(_vm._s(_vm.review.text))])]), _vm._v(" "), _c('div', {
    staticClass: "review-block webinar-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.review.webinar.date))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.review.webinar.theme))]), _vm._v(" "), (_vm.review.webinar.webinarSpeaker && _vm.review.webinar.webinarSpeaker.name) ? _c('span', [_vm._v(" Спикер: " + _vm._s(_vm.review.webinar.webinarSpeaker.name))]) : _vm._e()]), _vm._v(" "), (!_vm.review.isPublished) ? _c('div', {
    staticClass: "publish",
    on: {
      "click": function($event) {
        return _vm.publishWebinarReview(_vm.review.id)
      }
    }
  }, [_vm._v("\n    Опубликовать\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc940e7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/WebinarReviewItem.vue
// module id = 1001
// module chunks = 0